import * as base from '../base/mbase.js';
var getQueryStr  = base.getQueryStr;

/**
 * 开放获取 msdk打开页面的登陆态。
 * 
 * @returns 
 */
function getMsdkLogin(){
    var sevenParam = [
        'sig',
        'timestamp',
        'algorithm',
        'version',
        'encode',
        'msdkEncodeParam',
        'appid'
    ];
    var login = {};
    for(var i=0,len=sevenParam.length;i<len;i++){
        var p = getQueryStr(sevenParam[i]);
        login[sevenParam[i]] = p || '';
    }

    return login;
}

export default {
    getMsdkLogin    : getMsdkLogin
};